import React from "react";
import { Grid, IconButton, Stack } from "@mui/material";
import FeatherIcon from "feather-icons-react";
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/table/list.jsx";
import { CustomTooltip } from "../../consts.js";
import Utils from "../../utils.js";
import { DATE_FORMAT, PLAYLIST_FILTERS_OPTIONS } from "../../helpers/constant.js";
import { format } from "date-fns";
import { useThemeMode } from "../../components/theme/index.jsx";

function Playlists() {
    let navigate = useNavigate();
    const [data, setData] = React.useState([]);
    const [spinner, setSpinner] = React.useState(false);
    const { colours } = useThemeMode();

    async function getCampaignData() {
        Utils.sendProgressBar(true);
        setSpinner(true);

        let allItems = [];
        let nextToken = null;

        try {
            do {
                let response = await Utils.genericList("listConversations", {
                    filter: { bookmarks: { attributeExists: true } },
                    limit: 1000,
                    nextToken: nextToken, // Use the token to fetch the next page
                    fetchPolicy: "network-only", // Force fetch fresh data
                });

                // Add items from the current response to allItems
                allItems = allItems.concat(response.data.listConversations.items);

                // Update the nextToken for the next iteration
                nextToken = response.data.listConversations.nextToken;
            } while (nextToken); // Continue fetching as long as there's a nextToken
            for (const item of allItems) {
                item.campaignName = item.campaign?.name || "";
            }
            setData(allItems);
            setSpinner(false); // Update the state with all items
        } catch (error) {
            console.error("Error fetching campaign data: ", error);
        }
    }

    React.useEffect(() => {
        setSpinner(true);
        getCampaignData();
    }, []);

    // define table headers
    const columns = [
        {
            label: "File",
            key: "file",
            sortable: true,
            renderItem: (row) => (<Stack
                direction="row"
                alignItems="center"
                gap={1}
            >
                <CustomTooltip title={"View Details"}>
                    <IconButton color="primary"
                        onClick={() => navigate("/conversation?id=" + row.id)}
                        sx={colours.shadowMd}
                        aria-label="Play"
                    >
                        <FeatherIcon icon="play" />
                    </IconButton>
                </CustomTooltip>
                {row.file || "-"}
            </Stack>)
        },
        {
            label: "Agent",
            key: "agent",
            sortable: true,
            renderItem: (row) => row.agent || "-",
        },
        {
            label: "Campaign",
            key: "campaignName",
            sortable: true,
            renderItem: (row) => (<>
                <div
                    style={{
                        fontWeight: 500,
                    }}
                >
                    {row?.campaign?.name || "-"}
                </div>
                <div>
                    {row.company}
                </div>
            </>)
        },
        {
            label: "Conversation Date",
            key: "startdate",
            sortable: true,
            renderItem: (row) => (<>
                {format(new Date(row.startdate), DATE_FORMAT) || "-"}
            </>)
        },
        {
            label: "Sentiment",
            key: "sentiment",
            sortable: true,
            renderItem: (row) => (<>
                {row.sentiment === "positive" ? (
                    <div style={{ color: colours.green100 }}>
                        Positive
                    </div>
                ) : null}
                {row.sentiment === "negative" ? (
                    <div style={{ color: colours.critical100 }}>
                        Negative
                    </div>
                ) : null}
                {row.sentiment === "neutral" ? (
                    <div style={{ color: colours.black }}>Neutral</div>
                ) : null}
                {row.sentiment === null ? (
                    <div style={{ color: colours.black }}>Neutral</div>
                ) : null}
            </>)
        },
    ]

    return (
        <Grid display="flex" flexDirection="column" flexGrow="1" overflow="auto">
            <Grid
                className="vocalysed-home-upadted campaigns"
                container
                spacing={0}
                direction="column"
                flexWrap="nowrap"
                flexGrow={1}
                paddingTop={2}
                paddingX={3}
                paddingBottom={3}
                overflow="auto"
            >
                <TableComponent
                    spinner={spinner}
                    data={data}
                    columns={columns}
                    pagination={true}
                    searchKeys={["file", "agent", "campaign.name"]}
                    noDataMessage={"No playlist found."}
                    filterTypes={{ playListBookmark: "bookmarks" }}
                    defaultFilterValues={{ playListBookmark: PLAYLIST_FILTERS_OPTIONS[0] }}
                    rowClick={(item) => navigate("/conversation?id=" + item.id)}
                />
            </Grid>
        </Grid>
    );
}

export default Playlists;
